(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Bundle-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bundle-viewport]').forEach(function (viewport) {
    var track = viewport.querySelector('[data-bundle-track]');
    var originalSlides = Array.prototype.slice.call(viewport.querySelectorAll('[data-bundle-slide]'));
    var section = viewport.closest('.bundle-carousel');
    var navs = Array.prototype.slice.call(section.querySelectorAll('[data-bundle-nav]'));
    var loopEnabled = viewport.getAttribute('data-loop') === 'true';

    if (!track || originalSlides.length === 0) return;

    // Nothing to loop/scroll with 0-1 slides.
    if (navs.length === 0 || originalSlides.length < 2) {
      track.style.transform = 'translateX(0)';
      navs.forEach(function (nav) { nav.hidden = true; });
      return;
    }

    var perViewDesktop = parseInt(viewport.getAttribute('data-per-view-desktop'), 10) || 3;
    var N = originalSlides.length;
    // Clone at most as many slides as the widest possible "per view" (4),
    // capped to N so we never clone more than actually exists.
    var CLONE_COUNT = loopEnabled ? Math.min(N, 4) : 0;
    var slides = originalSlides;
    var isTransitioning = false;
    var lastDotCount = -1;

    if (loopEnabled && CLONE_COUNT > 0) {
      var headClones = originalSlides.slice(N - CLONE_COUNT).map(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('data-clone', 'true');
        c.setAttribute('aria-hidden', 'true');
        return c;
      });
      var tailClones = originalSlides.slice(0, CLONE_COUNT).map(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('data-clone', 'true');
        c.setAttribute('aria-hidden', 'true');
        return c;
      });

      headClones.forEach(function (c) { track.insertBefore(c, track.firstChild); });
      tailClones.forEach(function (c) { track.appendChild(c); });

      slides = Array.prototype.slice.call(track.querySelectorAll('[data-bundle-slide]'));
    }

    // In loop mode currentIndex is into the extended (clone+real+clone) track,
    // starting at the first real slide. In non-loop mode it's a plain 0..N-1 index.
    var currentIndex = loopEnabled ? CLONE_COUNT : 0;

    function getPerView() {
      var w = window.innerWidth;
      if (w <= 599) return 1;
      if (w <= 989) return 2;
      return perViewDesktop;
    }

    function getMaxIndex() {
      return Math.max(0, N - getPerView());
    }

    function realIndexFromCurrent() {
      if (!loopEnabled) return currentIndex;
      return ((currentIndex - CLONE_COUNT) % N + N) % N;
    }

    function buildDots() {
      var dotCount = loopEnabled ? N : (getMaxIndex() + 1);
      if (dotCount === lastDotCount) return;
      lastDotCount = dotCount;

      navs.forEach(function (nav) {
        var dotsContainer = nav.querySelector('[data-bundle-dots]');
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        for (var i = 0; i < dotCount; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bundle-carousel__dot';
          dot.setAttribute('data-bundle-dot', '');
          dot.setAttribute('data-index', i);
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dotsContainer.appendChild(dot);
        }
      });
    }

    function moveTo(index, withTransition) {
      var slideWidth = slides[0].getBoundingClientRect().width;
      var trackStyle = getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      var offset = index * (slideWidth + gap);

      if (!withTransition) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + (-offset) + 'px)';
        // Force reflow so the browser applies the position with no transition
        // before we hand control back to the default (CSS-defined) transition.
        track.getBoundingClientRect();
        track.style.transition = '';
      } else {
        track.style.transform = 'translateX(' + (-offset) + 'px)';
      }
    }

    function updateUI() {
      buildDots();
      var realIndex = realIndexFromCurrent();

      navs.forEach(function (nav) {
        var dotsContainer = nav.querySelector('[data-bundle-dots]');
        var dots = dotsContainer ? Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-bundle-dot]')) : [];
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === realIndex);
        });

        var prevBtn = nav.querySelector('[data-bundle-prev]');
        var nextBtn = nav.querySelector('[data-bundle-next]');
        if (prevBtn) prevBtn.disabled = loopEnabled ? false : currentIndex === 0;
        if (nextBtn) nextBtn.disabled = loopEnabled ? false : currentIndex >= getMaxIndex();
      });
    }

    function update(withTransition) {
      if (withTransition === undefined) withTransition = true;

      if (!loopEnabled) {
        var maxIndex = getMaxIndex();
        if (maxIndex <= 0) {
          currentIndex = 0;
          moveTo(0, withTransition);
          navs.forEach(function (nav) { nav.hidden = true; });
          lastDotCount = -1;
          return;
        }
        navs.forEach(function (nav) { nav.hidden = false; });
        if (currentIndex > maxIndex) currentIndex = maxIndex;
        if (currentIndex < 0) currentIndex = 0;
        moveTo(currentIndex, withTransition);
        updateUI();
        return;
      }

      navs.forEach(function (nav) { nav.hidden = false; });
      moveTo(currentIndex, withTransition);
      updateUI();
    }

    function goNext() {
      if (isTransitioning) return;
      currentIndex += 1;
      update(true);

      if (loopEnabled && currentIndex >= CLONE_COUNT + N) {
        isTransitioning = true;
        track.addEventListener('transitionend', function handler() {
          track.removeEventListener('transitionend', handler);
          currentIndex -= N;
          moveTo(currentIndex, false);
          isTransitioning = false;
        });
      }
    }

    function goPrev() {
      if (isTransitioning) return;
      currentIndex -= 1;
      update(true);

      if (loopEnabled && currentIndex < CLONE_COUNT) {
        isTransitioning = true;
        track.addEventListener('transitionend', function handler() {
          track.removeEventListener('transitionend', handler);
          currentIndex += N;
          moveTo(currentIndex, false);
          isTransitioning = false;
        });
      }
    }

    function goToRealIndex(i) {
      if (isTransitioning) return;
      if (loopEnabled) {
        currentIndex = CLONE_COUNT + i;
      } else {
        currentIndex = Math.min(i, getMaxIndex());
      }
      update(true);
    }

    navs.forEach(function (nav) {
      var prevBtn = nav.querySelector('[data-bundle-prev]');
      var nextBtn = nav.querySelector('[data-bundle-next]');
      var dotsContainer = nav.querySelector('[data-bundle-dots]');

      if (prevBtn) prevBtn.addEventListener('click', goPrev);
      if (nextBtn) nextBtn.addEventListener('click', goNext);

      if (dotsContainer) {
        dotsContainer.addEventListener('click', function (e) {
          var dot = e.target.closest('[data-bundle-dot]');
          if (!dot) return;
          var i = parseInt(dot.getAttribute('data-index'), 10);
          goToRealIndex(i);
        });
      }
    });

    window.addEventListener('resize', function () { update(false); });
    window.addEventListener('load', function () { update(false); });
    update(false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Video-ethos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-video-ethos-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.video-ethos__video-wrap');
        var player = wrap.querySelector('[data-video-ethos-player]');
        var url = btn.getAttribute('data-video-url');
        if (!player || !url) return;

        var embedHtml = '';
        if (url.indexOf('youtube.com') !== -1 || url.indexOf('youtu.be') !== -1) {
          var ytId = '';
          var ytMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?/]+)/);
          if (ytMatch) ytId = ytMatch[1];
          // muted on autoplay
          embedHtml = '<iframe src="https://www.youtube.com/embed/' + ytId + '?autoplay=1&mute=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
        } else if (url.indexOf('vimeo.com') !== -1) {
          var vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
          var vimeoId = vimeoMatch ? vimeoMatch[1] : '';
          // muted on autoplay
          embedHtml = '<iframe src="https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&muted=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
        } else {
          // muted on autoplay
          embedHtml = '<video src="' + url + '" controls autoplay muted playsinline></video>';
        }

        player.innerHTML = embedHtml;
        player.hidden = false;
        btn.style.display = 'none';

        var caption = wrap.querySelector('.video-ethos__caption');
        if (caption) caption.style.display = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doctor-review-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-testimonial-viewport]').forEach(function (viewport) {
      var track = viewport.querySelector('[data-testimonial-track]');
      var slides = Array.prototype.slice.call(viewport.querySelectorAll('[data-testimonial-slide]'));
      var section = viewport.closest('.testimonial-carousel');
      var nav = section.querySelector('[data-testimonial-nav]');
      var prevBtn = section.querySelector('[data-testimonial-prev]');
      var nextBtn = section.querySelector('[data-testimonial-next]');
      var dotsContainer = section.querySelector('[data-testimonial-dots]');

      if (!track || slides.length === 0) return;

      if (!nav) {
        track.style.transform = 'translateX(0)';
        return;
      }

      var perViewDesktop = parseInt(viewport.getAttribute('data-per-view-desktop'), 10) || 4;
      var currentIndex = 0;
      var lastDotCount = -1;

      function getPerView() {
        var w = window.innerWidth;
        if (w <= 599) return 1;
        if (w <= 989) return 2;
        return perViewDesktop;
      }

      function getMaxIndex() {
        return Math.max(0, slides.length - getPerView());
      }

      function buildDots(maxIndex) {
        var dotCount = maxIndex + 1;
        if (dotCount === lastDotCount || !dotsContainer) return;
        lastDotCount = dotCount;

        dotsContainer.innerHTML = '';
        for (var i = 0; i < dotCount; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'testimonial-carousel__dot';
          dot.setAttribute('data-testimonial-dot', '');
          dot.setAttribute('data-index', i);
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dotsContainer.appendChild(dot);
        }
      }

      function update() {
        var maxIndex = getMaxIndex();

        if (maxIndex <= 0) {
          currentIndex = 0;
          track.style.transform = 'translateX(0)';
          nav.classList.add('is-hidden');
          lastDotCount = -1;
          return;
        }

        nav.classList.remove('is-hidden');
        buildDots(maxIndex);

        if (currentIndex > maxIndex) currentIndex = maxIndex;
        if (currentIndex < 0) currentIndex = 0;

        var slideWidth = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var offset = currentIndex * (slideWidth + gap);
        track.style.transform = 'translateX(' + (-offset) + 'px)';

        var dots = dotsContainer ? Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-testimonial-dot]')) : [];
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
        });

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          currentIndex = Math.max(0, currentIndex - 1);
          update();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          currentIndex = Math.min(getMaxIndex(), currentIndex + 1);
          update();
        });
      }

      if (dotsContainer) {
        dotsContainer.addEventListener('click', function (e) {
          var dot = e.target.closest('[data-testimonial-dot]');
          if (!dot) return;
          var i = parseInt(dot.getAttribute('data-index'), 10);
          currentIndex = Math.min(i, getMaxIndex());
          update();
        });
      }

      window.addEventListener('resize', update);
      update();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
